export const planGroupConfig = {
  labels: {
    med: 'Medication(s)',
    refer: 'Referral',
    labs: 'Lab(s)',
    monitor: 'Monitor',
    other: 'Other',
  },
  placeholders: {
    med: 'Medication(s) status, name, and dosage...',
    refer: 'Referral type and/or provider...',
    labs: 'Lab name(s) and frequency...',
    monitor: 'Follow up appointment(s)...',
    other: 'Free text...',
  },
  defaultValue: [
    {
      type: 'med',
      text: '',
      checked: false,
    },
    {
      type: 'refer',
      text: '',
      checked: false,
    },
    {
      type: 'labs',
      text: '',
      checked: false,
    },
    {
      type: 'monitor',
      text: '',
      checked: false,
    },
    {
      type: 'other',
      text: '',
      checked: false,
    },
  ],
};
